module.exports = __webpack_public_path__ + "media/images/gift_img-5577df613b0cc60bef70baeda22937e0.svg";